import { render, staticRenderFns } from "./CompanySynonymsTable.vue?vue&type=template&id=76e84faa&scoped=true&"
import script from "./CompanySynonymsTable.vue?vue&type=script&lang=js&"
export * from "./CompanySynonymsTable.vue?vue&type=script&lang=js&"
import style0 from "./CompanySynonymsTable.vue?vue&type=style&index=0&id=76e84faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e84faa",
  null
  
)

export default component.exports